import React, { useEffect, useState } from "react";
import "./pixSubscriptionSection.css";

import QRCode from "react-qr-code";
import {
  ArrowLeftIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";
import orionAPI from "../../../config/orionAPI";
import { ClipLoader } from "react-spinners";

import useUser from "../../../hooks/useUser";

function PixSubscriptionSection({
  selectedPlan,
  setPage,
  setPaymentConfirmed,
  setPaymentInitiated,
}) {
  const [pixCode, setPixCode] = useState("");
  const [temp, setTemp] = useState(0);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [loading, setLoading] = useState(false);

  const { fetchUser, user } = useUser();

  const handleReturnPage = () => {
    setPage("select-section");
  };

  const fetchUserSubscription = async () => {
    try {
      await fetchUser();
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    const i = setInterval(() => {
      setTemp((prevTemp) => prevTemp + 1);
    }, 10000);

    return () => {
      clearInterval(i);
    };
  }, []);

  useEffect(() => {
    if (hasInitialized) {
      fetchUserSubscription();
    }
  }, [temp, hasInitialized]);

  useEffect(() => {
    if (user?.subscription) {
      setPaymentConfirmed(true);
    }
  }, [user, setPaymentConfirmed]);

  const copyPixCode = () => {
    navigator.clipboard.writeText(pixCode);
  };

  const getPixCode = async (planId) => {
    if (!planId) return;

    setLoading(true);
    try {
      const response = await orionAPI.post("api/users/me/subscribe/pix", {
        subscription_plan_id: planId,
      });
      setPixCode(response.data.data.emv);
      setHasInitialized(true);
      setPaymentInitiated(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedPlan?.id && !hasInitialized) {
      getPixCode(selectedPlan.id);
    }
  }, [selectedPlan?.id, hasInitialized]);

  return (
    <div className="orion__second-section">
      <div className="orion__pix-header">
        <button className="orion__return-button" onClick={handleReturnPage}>
          <ArrowLeftIcon className="icon" />
        </button>
      </div>

      <div className="orion__plan-summary-detailed">
        <div className="orion__plan-info">
          <h4>Preço selecionado</h4>
          <div className="orion__plan-details">
            <div className="orion__plan-price">
              <span className="orion__amount">{selectedPlan.price}</span>
              <span className="orion__currency">
                {selectedPlan.currency || "BRL"}
              </span>
            </div>
            <div className="orion__plan-duration">
              <strong>{selectedPlan.duration_in_days} dias</strong> de acesso
              completo
            </div>
            <div className="orion__payment-method">Pagamento via PIX</div>
          </div>
        </div>
      </div>
      {loading ? (
        <ClipLoader
          color="#D42A5B"
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
          className="orion__loading"
        />
      ) : (
        <>
          <div className="orion__qr-container">
            <QRCode className="orion__qr-code" value={pixCode} />
          </div>
          <div className="orion__pix-code">{pixCode}</div>
          <button className="orion__copy-button" onClick={copyPixCode}>
            <DocumentDuplicateIcon className="orion__copy-icon" />
            <span>COPIAR CÓDIGO</span>
          </button>
        </>
      )}
      <small>
        Por favor, ao efetuar o pagamento, espere de 1 a 2 minutos para a
        confirmação.
      </small>
    </div>
  );
}

export default PixSubscriptionSection;
